import { createSlice } from '@reduxjs/toolkit'
import { setErrorPage, unsetErrorPage } from './errorSlice'
import { setLoader, unsetLoader } from './loaderSlice'
import { getErrorMessage } from '../api/ApiDataHelper'
import data from '../helpers/DataHelper'

const initialState = {
  projectPageInitialized: false,
  currentProject: null,
}

export const initProjectPage = createSlice({
  name: 'initProjectPage',
  initialState,
  reducers: {
    resetInitProjectPageState: () => initialState,
    setProjectPageInitialized: (state, action) => {
      state.projectPageInitialized = action.payload
    },
    setCurrentProject: (state, action) => {
      state.currentProject = action.payload
    }
  }
})

export const {
  resetInitProjectPageState,
  setProjectPageInitialized,
  setCurrentProject
} = initProjectPage.actions

export const initializeProjectPage = (projectId) => async (dispatch, getState) => {
  window.scrollTo(0, 0)
  dispatch(unsetErrorPage())
  const state = getState()
  const { projectPageInitialized } = state.initProjectPage
  if (!projectPageInitialized) {
    dispatch(setLoader())
    try {
      dispatch(setCurrentProject(data.projects[projectId]));
      await data.projects[projectId].imgCover;
      dispatch(setProjectPageInitialized(true))
    }
    catch (error) {
      if (error.response?.status !== 401) {
        dispatch(setErrorPage({
          title: 'Errore richiesta server, impossibile inizializzare la pagina',
          message: getErrorMessage(error)
        }))
      }
    }
    finally {
      dispatch(unsetLoader())
    }
  }
}

export default initProjectPage.reducer
